function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var IMAGE_NAMES = ['png', 'jpg', 'jpeg', 'webp', 'svg'];
var FIELD = /this\.(name|description|status|class|categories)\s*=\s*(?:'([^']*)'|"([^"]*)"|`([^`]*)`)/g;
function moduleName(name) {
  var value = String(name || '');
  if (!/^[a-z0-9_-]+$/i.test(value)) {
    return '';
  }
  return value;
}
function assignment(source, field) {
  FIELD.lastIndex = 0;
  var match;
  while (match = FIELD.exec(source)) {
    if (match[1] === field) {
      var _ref, _ref2, _match$;
      return (_ref = (_ref2 = (_match$ = match[2]) !== null && _match$ !== void 0 ? _match$ : match[3]) !== null && _ref2 !== void 0 ? _ref2 : match[4]) !== null && _ref !== void 0 ? _ref : '';
    }
  }
  return '';
}
function imageFile(fs, path, module_dir, name) {
  var _iterator = _createForOfIteratorHelper(IMAGE_NAMES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ext = _step.value;
      var file = path.join(module_dir, 'web', 'img', "".concat(name, ".").concat(ext));
      try {
        if (fs.existsSync(file) && fs.statSync(file).isFile()) {
          return file;
        }
      } catch (err) {
        continue;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return '';
}
function readModuleMetadata(fs, path, modules_dir, name) {
  var module_name = moduleName(name);
  if (!fs || !path || !module_name) {
    return {};
  }
  var module_dir = path.join(modules_dir, module_name);
  var entry = path.join(module_dir, "".concat(module_name, ".js"));
  var source = '';
  try {
    source = fs.readFileSync(entry, 'utf8');
  } catch (err) {
    return {};
  }
  var categories = assignment(source, 'categories').split(/\s+/).map(function (item) {
    return item.trim();
  }).filter(Boolean);
  var metadata = {
    title: assignment(source, 'name') || module_name,
    description: assignment(source, 'description'),
    categories: categories,
    status: assignment(source, 'status'),
    "class": assignment(source, 'class')
  };
  if (imageFile(fs, path, module_dir, module_name)) {
    metadata.image = "/admin/module-image/".concat(encodeURIComponent(module_name));
  }
  return metadata;
}
function contentType(file) {
  if (file.endsWith('.png')) return 'image/png';
  if (file.endsWith('.jpg') || file.endsWith('.jpeg')) return 'image/jpeg';
  if (file.endsWith('.webp')) return 'image/webp';
  if (file.endsWith('.svg')) return 'image/svg+xml';
  return 'application/octet-stream';
}
function serveModuleImage(fs, path, modules_dir, req, res) {
  var _req$params;
  var module_name = moduleName(req === null || req === void 0 || (_req$params = req.params) === null || _req$params === void 0 ? void 0 : _req$params.module);
  if (!fs || !path || !module_name) {
    res.status(404).end();
    return;
  }
  var file = imageFile(fs, path, path.join(modules_dir, module_name), module_name);
  if (!file) {
    res.status(404).end();
    return;
  }
  res.setHeader('Content-Type', contentType(file));
  res.sendFile(file);
}
module.exports = {
  readModuleMetadata: readModuleMetadata,
  serveModuleImage: serveModuleImage
};